import Vue from 'vue'
import Router from 'vue-router'

import Editor from './views/Editor.vue'
import Login from './views/Login.vue'
import Cadastro from './views/Cadastro.vue'
import Teste from './views/Teste.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Editor
    },
    {
      path: '/home',
      name: 'home2',
      component: Editor
    },
    {
      path: '/editor',
      name: 'editor',
      component: Editor
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/cadastro',
      name: 'cadastro',
      component: Cadastro
    },
    {
      path: '/teste',
      name: 'teste',
      component: Teste
    }
  ]
})
